module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEABAMAAACuXLVVAAAAD1BMVEUAAAAAAAAAAAAKkTAO0UVm016hAAAAA3RSTlMADQ6oYJeUAAAAd0lEQVR4Xu3XwQ2AIBREQYyNmNgA8dOB9F+TZ/D+NWGmgX3XLT8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMSjZtuiDOEqus0+ukqv1yV1y9Zf6twABAgQIECBAgAABAgQIECAg/54vFrC3ab+WZHsMalkMAAA8eFe2M7XrR4EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/signal-1.png
// module id = 1168
// module chunks = 0